import React, { useState } from 'react'
import Close from '../../assets/assets/VectorClose.svg'
import Recaptcha from 'react-google-recaptcha'
import { Alert, Col, Row } from 'react-bootstrap'
import axios from 'axios'
import { baseUrl } from '../../consts/consts'
import logo1 from '../../assets/reading-side.svg'

const BookNowForm = ({ setShow, teacherId }) => {
  const [captchaSucces, setCaptchaSuccess] = useState(false)
  const [loader, setLoader] = useState(false)
  const [error, setError] = useState('')
  const [showTeacherDetails, setShowTeacherDetails] = useState(false)
  const [teacher, setTeacher] = useState(null)

  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    designation: '',
  })

  const inputHandler = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    // Validate hCaptcha response
    if (captchaSucces) {
      await formSubmitHandler()
    } else {
      alert('All fields are required')
    }
  }

  const formSubmitHandler = async () => {
    setLoader(true)
    try {
      if (
        formData.user_name === '' ||
        formData.user_email === '' ||
        formData.designation === ''
      ) {
        setError('All fields are required')
        setLoader(false)
        return
      }
      const request = {
        teacher_id: teacherId,
        ...formData,
      }
      const { data } = await axios.post(`${baseUrl}/visitor/add`, request)

      if (data.error) {
        setError(data.message)
        setLoader(false)
        return
      }
      setError('')
      setTeacher(data.data)
      setShowTeacherDetails(true)
      setLoader(false)
    } catch (error) {
      setError('Something went wrong, please try after some time')
      setLoader(false)
    }
  }
  const succesHandler = () => {
    setCaptchaSuccess(true)
  }

  return (
    <div className='InputForm book-now-form animate-bottom'>
      {!showTeacherDetails && (
        <div className='container'>
          <div className='close-icon'>
            <img
              src={Close}
              alt='closeButton'
              onClick={() => setShow(false)}
              className='cursor-pointer'
            />
          </div>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h2
              className=''
              style={{
                color: 'green',
                fontWeight: 'bold',
                fontSize: '34px',
                marginTop: 35,
              }}
            >
              Please Fill Required Details
            </h2>
          </div>
          <div className='inner-container'>
            <div className='input-form-left-container' style={{ padding: 70 }}>
              <img src={logo1} className='img-fluid' alt='logo' />
            </div>
            <div className='input-form-right-container'>
              <form action='' onSubmit={handleSubmit}>
                {error && (
                  <Alert variant='danger' style={{ display: 'flex' }}>
                    {error}
                  </Alert>
                )}
                <Row>
                  <Col md={12}>
                    <div className='custom-input-group'>
                      <label for='user_name'>Name *</label>
                      <input
                        type='text'
                        placeholder='John Doe'
                        name='user_name'
                        id='user_name'
                        onChange={inputHandler}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className='custom-input-group'>
                      <label for='user_email'>Email *</label>
                      <input
                        type='email'
                        placeholder='example@xyz.com'
                        name='user_email'
                        id='user_email'
                        onChange={inputHandler}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className='custom-input-group'>
                      <label for='designation'>Designation *</label>
                      <input
                        type='text'
                        placeholder='Sr. Software Engineer'
                        name='designation'
                        id='designation'
                        onChange={inputHandler}
                      />
                    </div>
                  </Col>
                </Row>
                <div className='captchaBox'>
                  <Recaptcha
                    sitekey='6Lc34ycmAAAAAE4XuOczDOAUWWNGIfOecd6WnJQd'
                    onChange={succesHandler}
                  />
                </div>

                <div className='d-flex justify-content-start'>
                  {loader && (
                    <button
                      className='RegButton mt-2 disabled'
                      type='submit'
                      onClick={(e) => {
                        e.preventDefault()
                      }}
                    >
                      Please Wait
                    </button>
                  )}
                  {!loader && (
                    <button className='RegButton mt-2' type='submit'>
                      SUBMIT
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {showTeacherDetails && teacher && (
        <div className='show-details' style={{ color: '#000' }}>
          <div className='d-flex justify-content-end p'>
            <img
              src={Close}
              alt='closeButton'
              onClick={() => setShow(false)}
              className=' cursor-pointer'
            ></img>
          </div>
          <p
            className='mx-auto text-xl'
            style={{ fontWeight: 600, textAlign: 'center' }}
          >
            Teacher's Details
          </p>
          <div className='d-flex book-now-div' style={{ marginTop: 30 }}>
            <p>Name</p>
            <p>{teacher.user_name}</p>
          </div>
          <div className='d-flex book-now-div'>
            <p>Email</p>
            <p>{teacher.user_email}</p>
          </div>
          <div className='d-flex book-now-div'>
            <p>Mobile</p>
            <p>{teacher.mobile_no}</p>
          </div>
          <div
            className='d-flex book-now-div'
            style={{ borderBottom: '1px solid #d3d3d3' }}
          >
            <p>View CV</p>
            <p>
              <a href={teacher.uploaded_cv} target='_blank' rel='noreferrer'>
                Click Here
              </a>
            </p>
          </div>
          <div style={{ textAlign: 'center', marginTop: 30 }}>
            <button className='RegButton mt-2' onClick={() => setShow(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
export default BookNowForm
